export { BaseMedicalInsuranceConfig } from './config';
